import { ReactComponent as _LogoRectangleNoTagLine } from './images/foodmesh_logo_rectangle_notagline.svg'
import { ReactComponent as _LogoRectangleTagLine } from './images/foodmesh_logo_rectangle_tagline.svg'
import { ReactComponent as _PearWhite } from './images/pear-white.svg'
import { ReactComponent as _DTIconDark } from './images/dt_icon_dark.svg'
import { ReactComponent as _PearGreenGradLogo } from './images/foodmesh-pear-circle-greengrad.svg';
import { ReactComponent as _NetworkPinBusiness } from './images/fm_food_business_white.svg';
import { ReactComponent as _NetworkPinRecipient } from './images/fm_donation_recipient_white.svg';
import { ReactComponent as _NetworkPinUpcycler } from './images/fm_upcycler_white.svg';
import { ReactComponent as _NetworkPinOther } from './images/fm_other_white.svg';

export const LogoWithNoTagLine = _LogoRectangleNoTagLine
export const LogoWithTagLine = _LogoRectangleTagLine
export const PearWhite = _PearWhite
export const DTIconDark = _DTIconDark
export const PearGreenGradLogo = _PearGreenGradLogo
export const NetworkPinBusiness = _NetworkPinBusiness
export const NetworkPinRecipient = _NetworkPinRecipient
export const NetworkPinUpcycler = _NetworkPinUpcycler
export const NetworkPinOther = _NetworkPinOther
